import { useDispatch, useSelector } from 'react-redux';
import FacetPanel from 'ps-components/FacetPanel/FacetPanel';
import { IAppState } from '../../../../lib/types';
import React, { useEffect, useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { bulkPricingActions } from './BulkPricingFacetPanelReducer';
import { IBulkPricingFacetPanelProps } from '../Types/BulkPricingTypes';
import { areAllFacetsUnchecked } from '../../../../lib/facetHelpers';
import { ALL_CURRENCIES_CODE } from '../../../../reducers/modules/currency/currency';
import './BulkPricingFacetPanel.scss';

export default function BulkPricingFacetPanel({ collapseCallback, collapseTooltip}: IBulkPricingFacetPanelProps) {
    const dispatch = useDispatch();
    const facetState = useSelector((state:any) => state.marketPricing.BulkPricing.FacetPanel);
    const session = useSelector((state: IAppState) => state.session);
    const facetActions = useMemo(() => bindActionCreators(bulkPricingActions, dispatch), [dispatch]);

    const anyFacetsUnselected = areAllFacetsUnchecked(facetState.facets, facetState.facetSelection);
    const showResetAllButton = !anyFacetsUnselected || (facetState.query && facetState.query !== '');
    const currency = session.currency.code !== ALL_CURRENCIES_CODE ? session.currency.code : null;

    useEffect(() => {
        facetActions.searchInputSearch('');
        return () => {
            facetActions.resetBulkPricingReducer();
        };
    }, [])

   function handleReset() {
    facetActions.handleReset().then(() => {
      facetActions.setCurrency(currency);
    });
    facetActions.searchInputSearch('');

  }

    return (
        <div>
            <FacetPanel
                title='Survey Search'
                className='bulk-pricing__facet-panel survey__job-facets'
                isLoaded={facetState.loaded}
                isUncheckedInitially={true}
                canCollapse={true}
                collapseCallback={collapseCallback}
                collapseTooltip={collapseTooltip}
                showSearchbox={true}
                searchBoxClass="bulk-pricing__facet-searchbox"
                {...facetState}
                {...facetActions}
                placeholderText='Search by job title, job code, or survey code'
                closeOnResize={true}
                showResetButton={showResetAllButton}
                resetSearch={handleReset}
            />
        </div>
    );
}
